"use client";
import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import {ToastContainerProps } from '../../utils/types/toast.types';
import Toast from './Toast';
import styles from './ToastContainer.module.scss';

export default function ToastContainer({ toasts, onRemoveToast }: ToastContainerProps) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) return null;

    return createPortal(
        <div className={styles.toastContainer}>
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    id={toast.id}
                    type={toast.type}
                    title={toast.title}
                    message={toast.message}
                    duration={toast.duration}
                    onClose={onRemoveToast}
                />
            ))}
        </div>,
        document.body
    );
}